import Main from './Main.vue'

export default [{
  path: 'relatorios/basico',
  name: 'relatorios-basico',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/relatorios-basicos/routes.js